import React, { useState, useEffect, useCallback } from "react";
import {
  Paper,
  Typography,
  MenuItem,
  Select,
  FormControl,
  TextField,
  TextareaAutosize,
  Switch,
  FormControlLabel,
} from "@mui/material";
import SearchFilter from "../../../Requirement/components/common/SearchFilter";
import DataTable from "../../../Requirement/components/common/ReusableTable";
import { useLoading } from "../../../../context/LoadingContext";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import config from "../../../../aws-exports";
import OfferDetails from "./component/OfferDetails";
import {
  fetchData,
  postQuery,
  postQueryBackendopsFun,
} from "../../../Requirement/services/RequirementServices";
import { useNavigate } from "react-router-dom";
import { getParameterFromManager } from "../../../../services/Utils";
import AlertModal from "../../../Requirement/components/common/AlerModel";
import "../../../../styles/general.css";
import "../../../../styles/amtpl.css";
import dayjs from "dayjs";
const MyOffers = () => {
  const navigate = useNavigate();
  const { setLoading, loading } = useLoading();
  const [gpOffers, setGPOffers] = useState([]);
  const [activeUser, setActiveUser] = useState("");
  const [products, setProducts] = useState([]);
  const [states, setStates] = useState([]);
  const [rowStart, setRowStart] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [INRToUsd, setINRToUSD] = useState(0.012);
  const [matchingOffersRequirement, setMatchingOffersRequirement] =
    useState(null);
  const [searchValues, setSearchValues] = useState({
    product: "",
    grade: "",
    state: "",
  });

  // Form state - copied from CreateOffersManual.js
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    // Commodity Details
    productName: "",
    hsCode: "",
    grade: "",
    variety: "",
    originCountry: "",
    destinationCountry: "",
    productSpecifications: "",
    productID: "",
    // Quantity/Packaging
    quantity: "",
    packagingType: "",
    packagingSize: "",
    additionalPackagingNotes: "",
    // Delivery/Logistic
    shippingMethodPreference: "",
    loadingPort: "",
    dischargePort: "",
    inco: "",
    transitTime: "",
    partialDeliveryAllowed: 0,
    // Pricing/Guarantee
    pricePerMT: "",
    paymentTerms: "",
    currency: "USD",
    sortingGradingCharges: "",
    financeOperationsCharges: "",
    inlandCharges: "",
    shippingCharges: "",
    margin: "",
    exportDuty: "",
    vat: "",
    platformCharges: "",
    // Others
    specialInstructionsBuyer: "",
    internalComments: "",
    OfferStatus: "Indicative",
    OfferType: "Manual",
  });

  // Additional state for form
  const [countries, setCountries] = useState([]);
  const [productId, setProductId] = useState("");
  const [selectedPrice, setSelectedPrice] = useState([]);
  const [activeTab, setActiveTab] = useState("commodityDetails");

  // Dynamic dropdown options
  const [packagingOptions, setPackagingOptions] = useState([]);
  const [paymentTermsOptions, setPaymentTermsOptions] = useState([]);
  const [incotermsOptions, setIncotermsOptions] = useState([]);
  const [loadingPorts, setLoadingPorts] = useState([]);
  const [dischargePorts, setDischargePorts] = useState([]);
  const [filteredPackageSizes, setFilteredPackageSizes] = useState([]);
  const [uniquePackagingTypes, setUniquePackagingTypes] = useState([]);


  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });
  const handleModalClose = () => {
    if (modal.nextAction) {
      modal.nextAction();
    }
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
  };

  // Form handling functions - copied from CreateOffersManual.js
  const handleFormChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Update productID when productName changes
    if (field === "productName") {
      const selectedProduct = products.find(
        (product) => product.ProductName === value
      );
      if (selectedProduct) {
        setProductId(selectedProduct.ProductID);
        setFormData((prev) => ({
          ...prev,
          productID: selectedProduct.ProductID,
          hsCode: selectedProduct.HSCode || "",
        }));
      }
    }
    if (field === "grade") {
      const selectedProduct = products.find(
        (product) => (product.ProductName === formData.productName && product.Grade===value)
      );
      if (selectedProduct) {
        setProductId(selectedProduct.ProductID);
        setFormData((prev) => ({
          ...prev,
          productID: selectedProduct.ProductID,
          hsCode: selectedProduct.HsCode || "",
          variety: selectedProduct.Variety || "",
        }));
      }
    }

    // Clear related port selections when country changes
    if (field === "originCountry") {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
        loadingPort: "", // Clear loading port when origin country changes
      }));
      setLoadingPorts([]); // Clear current loading ports
    } else if (field === "destinationCountry") {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
        dischargePort: "", // Clear discharge port when destination country changes
      }));
      setDischargePorts([]); // Clear current discharge ports
    }
  };

  // Handle packaging type change
  const handlePackagingChange = (e) => {
    const selectedPackaging = e.target.value;
    handleFormChange("packagingType", selectedPackaging);
    setFormData((prev) => ({
      ...prev,
      packagingType: selectedPackaging,
      packagingSize: "", // Reset packaging size when packaging type changes
    }));
    loadPackageSizes(selectedPackaging);
  };

  // Handle packaging size change
  const handlePackagingSizeChange = (e) => {
    handleFormChange("packagingSize", e.target.value);
  };

  // Handle tab click
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  // Handle form submission
  const handleFormSubmit = async () => {
    try {
      setLoading(true);

      // Validate required fields
      if (!formData.productName || !formData.quantity || !formData.pricePerMT) {
        setModal({
          show: true,
          type: "error",
          title: "Validation Error",
          message:
            "Please fill in all required fields (Product, Quantity, Price).",
          autoClose: false,
        });
        return;
      }

      // Add current form data to selectedPrice array

      // Prepare the body for generateAutomaticOffers service
      const body = {
        target: "createGPOfferGTP",
        item: formData,
      };

      console.log("Submitting offer with data:", body);

      const result = await postQuery(body);
      console.log("Offer creation response:", result);

      if (result && result.items?.success) {
        setModal({
          show: true,
          type: "success",
          title: "Success!",
          message: "Offer created successfully!",
          autoClose: false,
          nextAction: () => {
            handleReset();
            setShowForm(false);
            fetchGPOffers();
          },
        });
      } else {
        setModal({
          show: true,
          type: "error",
          title: "Error",
          message:
            "Error creating offer: " + (result?.message || "Unknown error"),
          autoClose: false,
        });
      }
    } catch (error) {
      console.error("Error creating offer:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: "Error creating offer: " + error.message,
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  // Fetch countries for dropdown
  const fetchCountries = async () => {
    try {
      const body = {
        target: "listDropDownOptions",
        filterTerms: { Type: "Country" },
        rowStart: 0,
        pageSize: 1000,
      };
      const result = await postQuery(body);
      if (result && result.items) {
        setCountries(result.items);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  // Fetch packaging options
  const fetchPackagingOptions = useCallback(async () => {
    try {
      const packagingData = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 100,
        filterTerms: { Type: "packaging" },
      });
      setPackagingOptions(packagingData?.items || []);
    } catch (error) {
      console.error("Error fetching packaging options:", error);
    }
  }, []);

  // Fetch payment terms
  const fetchPaymentTerms = useCallback(async () => {
    try {
      const paymentTermsData = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 1000,
        filterTerms: { Type: "paymentTerms" },
      });
      setPaymentTermsOptions(paymentTermsData?.items || []);
    } catch (error) {
      console.error("Error fetching payment terms:", error);
    }
  }, []);

  // Fetch incoterms
  const fetchIncoterms = useCallback(async () => {
    try {
      const incotermsData = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 1000,
        filterTerms: { Type: "Incoterms" },
      });
      setIncotermsOptions(incotermsData?.items || []);
    } catch (error) {
      console.error("Error fetching incoterms:", error);
    }
  }, []);

  // Fetch ports based on country
  const fetchPorts = useCallback(async (country, portType) => {
    if (!country) return;
    try {
      const portsData = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 500,
        filterTerms: { Type: "port", Subtype: country },
      });

      if (portType === "loading") {
        setLoadingPorts(portsData?.items || []);
      } else if (portType === "discharge") {
        setDischargePorts(portsData?.items || []);
      }
    } catch (error) {
      console.error(`Error fetching ${portType} ports:`, error);
    }
  }, []);

  // Load package sizes based on selected packaging type
  const loadPackageSizes = useCallback(
    (selectedPackaging) => {
      const filteredSizes = packagingOptions.filter(
        (item) => item.Subtype === selectedPackaging
      );
      setFilteredPackageSizes(filteredSizes);
    },
    [packagingOptions]
  );
  // Define currentPage before useEffect
  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const getBackendName = () => {
    const backend = config.aws_user_files_s3_bucket.split("-");
    return backend[backend.length - 1];
  };

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const body = {
        target: "listProducts",
        rowStart: 0,
        pageSize: 1000,
      };

      const result = await postQuery(body);
      console.log(result);
      if (result) {
        setProducts(result.items);
      } else {
        console.error("Error fetching products");
      }
    } catch (error) {
      console.error("Error fetching products: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStates = async () => {
    setLoading(true);
    try {
      const body = {
        target: "listDynamicDropDownOptions",
        option: "gpofferitemstates",
        rowStart: 0,
        pageSize: 1000,
      };

      const result = await postQuery(body);
      console.log(result);
      if (result) {
        setStates(result.items.map((option) => option.result));
      } else {
        console.error("Error fetching states: ", result);
      }
    } catch (error) {
      console.error("Error fetching states: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchGPOffers = async (searchValue, newRowStart = rowStart) => {
    setLoading(true);
    try {
      const filterTerms = {
        product: searchValues.product,
        grade: searchValues.grade,
        state: searchValues.state,
        IsApproved: 0,
      };

      const body = {
        target: "listGPOfferDetailsByUserType",

        filterTerms,
        userOrder: "CreatedAt DESC",
        //userOrder: "GPOfferID ASC",
        rowStart: newRowStart,
        pageSize: pageSize,
        userType: "GlobalPartner",
      };

      const result = await postQuery(body);
      if (result) {
        setGPOffers(result.items);
        setTotalItems(result.total);
        // Auto-select the first offer if available
        console.log(result.items);
        if (result.items.length > 0) {
          const firstOffer = result.items[0];
          console.log(firstOffer);
          //setSelectedOffer(firstOffer);
          //setMatchingOffersRequirement(firstOffer); // Keep states in sync
        } else {
          setSelectedOffer(null);
          setMatchingOffersRequirement(null); // Clear states if no offers
        }
      } else {
        console.error("Error fetching gpOffers: ", result);
        setSelectedOffer(null);
        setMatchingOffersRequirement(null); // Clear states on error
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
      setSelectedOffer(null);
      setMatchingOffersRequirement(null); // Clear states on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchStates();
    fetchCountries();
    fetchPackagingOptions();
    fetchPaymentTerms();
    fetchIncoterms();
    fetchGPOffers();
  }, [
    currentPage,
    searchValues,
    fetchPackagingOptions,
    fetchPaymentTerms,
    fetchIncoterms,
  ]);

  // Load unique packaging types when packaging options are fetched
  useEffect(() => {
    if (packagingOptions.length > 0) {
      const types = [
        ...new Set(
          packagingOptions.map((option) => option.Subtype).filter(Boolean)
        ),
      ];
      setUniquePackagingTypes(types);
    }
  }, [packagingOptions]);

  // Effect to fetch ports when origin country changes
  useEffect(() => {
    if (formData.originCountry) {
      fetchPorts(formData.originCountry, "loading");
    }
  }, [formData.originCountry, fetchPorts]);

  // Effect to fetch ports when destination country changes
  useEffect(() => {
    if (formData.destinationCountry) {
      fetchPorts(formData.destinationCountry, "discharge");
    }
  }, [formData.destinationCountry, fetchPorts]);

  const handlePageChange = (page) => {
    const newRowStart = (page - 1) * pageSize;
    setRowStart(newRowStart);
    fetchGPOffers(searchValues, newRowStart);
  };

  const handleRowClick = (offer) => {
    setSelectedOffer(offer);
    setMatchingOffersRequirement(offer); // Keep states in sync
    console.log(offer);
  };

  const handleSearch = () => {
    setRowStart(0);
    setSelectedOffer(null); // Reset selectedOffer on new search
    fetchGPOffers(searchValues, 0);
  };

  const handleReset = () => {
    setSearchValues({
      product: "",
      grade: "",
      state: "",
    });
    setRowStart(0);
    setSelectedOffer(null); // Reset selectedOffer on reset
  };

  const columns = [
    { id: "OfferNumber", numeric: false, label: "Offer No" },
    { id: "ProductName", numeric: false, label: "Product" },
    { id: "Grade", numeric: false, label: "Grade" },
    { id: "Quantity", numeric: false, label: "Quantity" },
    { id: "Price", numeric: false, label: "Price" },
    { id: "OriginCountry", numeric: false, label: "Orgin Country" },
    { id: "DestinationCountry", numeric: false, label: "Destination Country" },
    { id: "INCO", numeric: false, label: "Inco Term" },
    {
      id: "Expires",
      numeric: false,
      label: "Expires",
      renderCell: (row) =>
        row.Expires ? dayjs(row.Expires).format("DD-MM-YYYY") : "",
    },
    {
      id: "GPOOfferStatus",
      numeric: false,
      label: "Offer Type",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.GPOOfferStatus) {
          case "BAFO":
            bgColor = "#e0f2fe";
            textColor = "#0369a1";
            break;
          case "Firmoffer":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
            row.GPOOfferStatus = "Indicative"; // Set default status
            break;
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
            }}
          >
            {row.GPOOfferStatus}
          </span>
        );
      },
    },
    // { id: "OfferType", numeric: false, label: "OFFER TYPE" },
  ];

  const fields = [
    {
      name: "product",
      label: "Product",
      type: "dropdown",
      options: [...new Set(products.map((product) => product.ProductName))],
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, product: value })),
      value: searchValues.product,
    },
    {
      name: "grade",
      label: "Grade",
      type: "dropdown",
      options: [
        ...new Set(
          products
            .filter((product) => product.ProductName === searchValues.product)
            .map((product) => product.Grade)
        ),
      ],
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, grade: value })),
      value: searchValues.grade,
    },
    {
      name: "state",
      label: "State",
      type: "dropdown",
      options: states,
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, state: value })),
      value: searchValues.state,
    },
  ];
  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        // Check if the user is a member of the AMTPL_BUYERS group
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_GLOBAL_PARTNERS")) {
          await Auth.signOut(); // Sign out the user
          navigate("/login/global-partner");
        } else {
          setActiveUser(user.attributes.email); // Set the active user email
        }
        let inrToUsdVal = await getParameterFromManager("INR_TO_USD");
        inrToUsdVal = parseFloat(inrToUsdVal);
        setINRToUSD(inrToUsdVal);
      } catch (error) {
        await Auth.signOut(); // Sign out the user
        navigate("/login/global-partner");
      }
    };
    checkUser();
  }, [navigate]);
  //const selectedRows = selectedGPOffer? [selectedGPOffer.GPOfferID || selectedGPOffer.id]: [];
  const selectedRows = selectedOffer ? [selectedOffer.GPOfferID] : [];
  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div
        className="head-btn"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          alignItems: "end",
          marginRight: "12px",
        }}
      >
        <div
          className="submit-btn"
          onClick={() => {
            if (!showForm) {
              // Opening the form - clear selected offer, close offer details, and reset form
              setSelectedOffer(null);
              setMatchingOffersRequirement(null);
              // Reset form data to initial state
              setFormData({
                // Commodity Details
                productName: "",
                hsCode: "",
                grade: "",
                variety: "",
                originCountry: "",
                destinationCountry: "",
                productSpecifications: "",
                productID: "",
                // Quantity/Packaging
                quantity: "",
                packagingType: "",
                packagingSize: "",
                additionalPackagingNotes: "",
                // Delivery/Logistic
                shippingMethodPreference: "",
                loadingPort: "",
                dischargePort: "",
                inco: "",
                transitTime: "",
                partialDeliveryAllowed: 0,
                // Pricing/Guarantee
                pricePerMT: "",
                paymentTerms: "",
                currency: "USD",
                sortingGradingCharges: "",
                financeOperationsCharges: "",
                inlandCharges: "",
                shippingCharges: "",
                margin: "",
                exportDuty: "",
                vat: "",
                platformCharges: "",
                // Others
                specialInstructionsBuyer: "",
                internalComments: "",
                OfferStatus: "Indicative",
                OfferType: "Manual",
              });
              setProductId("");
              setFilteredPackageSizes([]); // Clear filtered package sizes
              handleReset();
              setShowForm(true);
              setActiveTab("commodityDetails"); // Ensure default tab is set
            } else {
              // Closing the form
              handleReset();
              setShowForm(false);
            }
          }}
        >
          {showForm ? "Cancel" : "Add"}
        </div>
      </div>
      <div className="search-filter4">
        <div className="title4">
          <div className="head-text">My Offers</div>
        </div>
        <div className="filter4">
          <SearchFilter
            fields={fields}
            onSearch={handleSearch}
            onReset={handleReset}
          />
        </div>
      </div>
      <div className="table-content">
        <DataTable
          columns={columns}
          data={gpOffers}
          onRowClick={handleRowClick}
          total={totalItems}
          title="Requirement Information"
          rowsPerPage={pageSize}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          selectedRows={selectedRows}
        />
      </div>
      {selectedOffer && !showForm ? (
        <div className="card offer-content1">
          <div className="header-text-re">
            <div className="head-text">Offer Details</div>
            <div className="tt0"></div>
          </div>
          <OfferDetails
            offer={selectedOffer}
            btnShortlist={false}
            btnSendQuery={false}
            btnRequestQuote={false}
            btnRequestSpecifications={false}
            btnRequestBestPrice={false}
            btnNegotiate={false}
            btnRequestShippingDetails={false}
            btnLogisticsSupport={false}
            btnRaiseQuery={true}
            INRToUsd={INRToUsd}
          />
        </div>
      ) : (
        !showForm && <div></div>
      )}

      {/* Create Offer Form - copied from CreateOffersManual.js */}
      {showForm && (
        <>
          <div className="row">
            <section className="product-details">
              {/* Submit and Cancel buttons positioned above tabs */}
              <div className="row" style={{ marginBottom: "20px" }}>
                <div className="col-lg-12 text-end">
                  <button
                    type="button"
                    className="submit-btn"
                    onClick={() => {
                      setShowForm(false);
                      handleReset();
                    }}
                    disabled={loading}
                  >
                    CANCEL
                  </button>
                  <button
                    type="button"
                    className="submit-btn"
                    onClick={handleFormSubmit}
                    disabled={loading}
                    style={{
                      marginLeft: "5px",
                    }}
                  >
                    {loading ? "SUBMITTING..." : "SUBMIT"}
                  </button>
                </div>
              </div>

              <div className="tabs">
                <button
                  className={activeTab === "commodityDetails" ? "active" : ""}
                  onClick={() => handleTabClick("commodityDetails")}
                >
                  Commodity Details
                </button>
                <button
                  className={activeTab === "specifications" ? "active" : ""}
                  onClick={() => handleTabClick("specifications")}
                >
                  Specifications
                </button>
                <button
                  className={activeTab === "quantityPackaging" ? "active" : ""}
                  onClick={() => handleTabClick("quantityPackaging")}
                >
                  Quantity/Packaging
                </button>
                <button
                  className={activeTab === "deliveryLogistic" ? "active" : ""}
                  onClick={() => handleTabClick("deliveryLogistic")}
                >
                  Delivery/Logistic
                </button>
                <button
                  className={activeTab === "pricing" ? "active" : ""}
                  onClick={() => handleTabClick("pricing")}
                >
                  Pricing/Guarantee
                </button>
                <button
                  className={activeTab === "others" ? "active" : ""}
                  onClick={() => handleTabClick("others")}
                >
                  Others
                </button>
              </div>

              {/* Commodity Details Tab */}
              {activeTab === "commodityDetails" && (
                <div className="tab-content active">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Product Name *</Typography>
                        <Select
                          value={formData.productName}
                          onChange={(e) =>
                            handleFormChange("productName", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select a product
                          </MenuItem>
                          {[
                            ...new Set(
                              products.map((product) => product.ProductName)
                            ),
                          ].map((productName) => (
                            <MenuItem key={productName} value={productName}>
                              {productName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">HS Code</Typography>
                      <TextField
                        value={formData.hsCode}
                        onChange={(e) =>
                          handleFormChange("hsCode", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter HS Code"
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Grade *</Typography>
                        <Select
                          value={formData.grade}
                          onChange={(e) =>
                            handleFormChange("grade", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                          disabled={!formData.productName}
                        >
                          <MenuItem value="" disabled>
                            Select a Grade
                          </MenuItem>
                          {products
                            .filter(
                              (product) =>
                                product.ProductName === formData.productName
                            )
                            .map((product) => (
                              <MenuItem
                                key={product.Grade}
                                value={product.Grade}
                              >
                                {product.Grade}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">Variety</Typography>
                      <TextField
                        value={formData.variety}
                        onChange={(e) =>
                          handleFormChange("variety", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Variety"
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">
                          Origin Country *
                        </Typography>
                        <Select
                          value={formData.originCountry}
                          onChange={(e) =>
                            handleFormChange("originCountry", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Origin Country
                          </MenuItem>
                          {countries.map((country) => (
                            <MenuItem key={country.Value} value={country.Value}>
                              {country.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">
                          Destination Country *
                        </Typography>
                        <Select
                          value={formData.destinationCountry}
                          onChange={(e) =>
                            handleFormChange(
                              "destinationCountry",
                              e.target.value
                            )
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Destination Country
                          </MenuItem>
                          {countries.map((country) => (
                            <MenuItem key={country.Value} value={country.Value}>
                              {country.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
              )}

              {/* Specifications Tab */}
              {activeTab === "specifications" && (
                <div className="tab-content active">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <Typography variant="body2">
                        Product Specifications
                      </Typography>
                      <TextareaAutosize
                        value={formData.productSpecifications}
                        onChange={(e) =>
                          handleFormChange(
                            "productSpecifications",
                            e.target.value
                          )
                        }
                        style={{
                          width: "100%",
                          minHeight: "120px",
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "8px",
                          fontFamily: "inherit",
                          fontSize: "14px",
                        }}
                        placeholder="Enter product specifications"
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Quantity/Packaging Tab */}
              {activeTab === "quantityPackaging" && (
                <div className="tab-content active">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <Typography variant="body2">Quantity (MT) *</Typography>
                      <TextField
                        type="number"
                        value={formData.quantity}
                        onChange={(e) =>
                          handleFormChange("quantity", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Quantity in MT"
                      />
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">Packaging Type</Typography>
                      <FormControl fullWidth sx={{ backgroundColor: "white" }}>
                        <Select
                          value={formData.packagingType}
                          onChange={handlePackagingChange}
                          displayEmpty
                        >
                          <MenuItem value="">Select Packaging Type</MenuItem>
                          {uniquePackagingTypes.map((type) => (
                            <MenuItem key={type} value={type}>
                              {type}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">Packaging Size</Typography>
                      <FormControl fullWidth sx={{ backgroundColor: "white" }}>
                        <Select
                          value={formData.packagingSize}
                          onChange={handlePackagingSizeChange}
                          displayEmpty
                          disabled={!formData.packagingType}
                        >
                          <MenuItem value="">Select Packaging Size</MenuItem>
                          {filteredPackageSizes.map((size) => (
                            <MenuItem
                              key={size.ID || size.Value}
                              value={size.Value}
                            >
                              {size.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">
                        Additional Packaging Notes
                      </Typography>
                      <TextField
                        value={formData.additionalPackagingNotes}
                        onChange={(e) =>
                          handleFormChange(
                            "additionalPackagingNotes",
                            e.target.value
                          )
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Additional Notes"
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Delivery/Logistic Tab */}
              {activeTab === "deliveryLogistic" && (
                <div className="tab-content active">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Shipping Method</Typography>
                        <Select
                          value={formData.shippingMethodPreference}
                          onChange={(e) =>
                            handleFormChange(
                              "shippingMethodPreference",
                              e.target.value
                            )
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Shipping Method
                          </MenuItem>
                          <MenuItem value="Road">Road</MenuItem>
                          <MenuItem value="Rail">Rail</MenuItem>
                          <MenuItem value="Ocean">Ocean</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Port of Loading</Typography>
                        <Select
                          value={formData.loadingPort}
                          onChange={(e) =>
                            handleFormChange("loadingPort", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                          disabled={!formData.originCountry}
                        >
                          <MenuItem value="" disabled>
                            {formData.originCountry
                              ? "Select Port of Loading"
                              : "Select Origin Country first"}
                          </MenuItem>
                          {loadingPorts.map((port) => (
                            <MenuItem key={port.Value} value={port.Value}>
                              {port.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">
                          Port of Destination
                        </Typography>
                        <Select
                          value={formData.dischargePort}
                          onChange={(e) =>
                            handleFormChange("dischargePort", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                          disabled={!formData.destinationCountry}
                        >
                          <MenuItem value="" disabled>
                            {formData.destinationCountry
                              ? "Select Port of Destination"
                              : "Select Destination Country first"}
                          </MenuItem>
                          {dischargePorts.map((port) => (
                            <MenuItem key={port.Value} value={port.Value}>
                              {port.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Incoterms</Typography>
                        <Select
                          value={formData.inco}
                          onChange={(e) =>
                            handleFormChange("inco", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Incoterms
                          </MenuItem>
                          {incotermsOptions.map((incoterm) => (
                            <MenuItem
                              key={incoterm.Value}
                              value={incoterm.Value}
                            >
                              {incoterm.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-4">
                      <Typography variant="body2">Transit Time</Typography>
                      <TextField
                        value={formData.transitTime}
                        onChange={(e) =>
                          handleFormChange("transitTime", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Transit Time"
                      />
                    </div>
                    <div className="col-md-6">
                      <FormControlLabel
                        control={
                          <Switch
                            checked={formData.partialDeliveryAllowed === 1}
                            onChange={(e) =>
                              handleFormChange(
                                "partialDeliveryAllowed",
                                e.target.checked ? 1 : 0
                              )
                            }
                          />
                        }
                        label="Partial Delivery Allowed"
                        sx={{ marginTop: "24px" }}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Pricing Tab */}
              {activeTab === "pricing" && (
                <div className="tab-content active">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <Typography variant="body2">Price per MT *</Typography>
                      <TextField
                        type="number"
                        value={formData.pricePerMT}
                        onChange={(e) =>
                          handleFormChange("pricePerMT", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Price per MT"
                      />
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">Currency *</Typography>
                      <TextField
                        value="USD"
                        sx={{ backgroundColor: "white", width: "100%" }}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Payment Terms</Typography>
                        <Select
                          value={formData.paymentTerms}
                          onChange={(e) =>
                            handleFormChange("paymentTerms", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Payment Terms
                          </MenuItem>
                          {paymentTermsOptions.map((paymentTerm) => (
                            <MenuItem
                              key={paymentTerm.Value}
                              value={paymentTerm.Value}
                            >
                              {paymentTerm.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">
                        Sorting Grading Charges (%)
                      </Typography>
                      <TextField
                        type="number"
                        value={formData.sortingGradingCharges}
                        onChange={(e) =>
                          handleFormChange(
                            "sortingGradingCharges",
                            e.target.value
                          )
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Sorting Grading Charges"
                      />
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">
                        Finance Operations Charges (%)
                      </Typography>
                      <TextField
                        type="number"
                        value={formData.financeOperationsCharges}
                        onChange={(e) =>
                          handleFormChange(
                            "financeOperationsCharges",
                            e.target.value
                          )
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Finance Operations Charges"
                      />
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">
                        Inland Charges (USD/MT)
                      </Typography>
                      <TextField
                        type="number"
                        value={formData.inlandCharges}
                        onChange={(e) =>
                          handleFormChange("inlandCharges", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Inland Charges"
                      />
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">
                        Shipping Charges (USD/MT)
                      </Typography>
                      <TextField
                        type="number"
                        value={formData.shippingCharges}
                        onChange={(e) =>
                          handleFormChange("shippingCharges", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Shipping Charges"
                      />
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">Margin (%)</Typography>
                      <TextField
                        type="number"
                        value={formData.margin}
                        onChange={(e) =>
                          handleFormChange("margin", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Margin"
                      />
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">Export Duty (%)</Typography>
                      <TextField
                        type="number"
                        value={formData.exportDuty}
                        onChange={(e) =>
                          handleFormChange("exportDuty", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Export Duty"
                      />
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">VAT (%)</Typography>
                      <TextField
                        type="number"
                        value={formData.vat}
                        onChange={(e) =>
                          handleFormChange("vat", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter VAT"
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Others Tab */}
              {activeTab === "others" && (
                <div className="tab-content active">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <Typography variant="body2">
                        Special Instructions for Buyer
                      </Typography>
                      <TextareaAutosize
                        value={formData.specialInstructionsBuyer}
                        onChange={(e) =>
                          handleFormChange(
                            "specialInstructionsBuyer",
                            e.target.value
                          )
                        }
                        style={{
                          width: "100%",
                          minHeight: "120px",
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "8px",
                          fontFamily: "inherit",
                          fontSize: "14px",
                        }}
                        placeholder="Enter special instructions"
                      />
                    </div>
                    <div className="col-md-12">
                      <Typography variant="body2">Internal Comments</Typography>
                      <TextareaAutosize
                        value={formData.internalComments}
                        onChange={(e) =>
                          handleFormChange("internalComments", e.target.value)
                        }
                        style={{
                          width: "100%",
                          minHeight: "120px",
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "8px",
                          fontFamily: "inherit",
                          fontSize: "14px",
                        }}
                        placeholder="Enter internal comments"
                      />
                    </div>
                  </div>
                </div>
              )}
            </section>
          </div>
        </>
      )}
    </Paper>
  );
};

export default MyOffers;
